import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20manga%20illustration%20style%20cozy%20warm%20grocery%20store%20interior%20filled%20with%20colorful%20comic%20books%20on%20wooden%20shelves%20soft%20golden%20afternoon%20sunlight%20streaming%20through%20window%20cute%20and%20whimsical%20atmosphere%20hand%20drawn%20aesthetic%20pastel%20warm%20tones%20of%20cream%20beige%20and%20soft%20orange%20detailed%20but%20not%20cluttered%20dreamy%20storybook%20vibe%20gentle%20shadows%20editorial%20quality%20inviting%20and%20nostalgic%20mood%20wide%20landscape%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
        alt="洞洞杂货铺漫画 - 温暖治愈的漫画世界"
        title="洞洞杂货铺漫画 - 温暖治愈的漫画世界"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <div className="text-center max-w-2xl">
          <p className="text-accent-300 text-sm md:text-base font-label mb-3 tracking-wider">
            —— 36漫画网 ——
          </p>
          <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 leading-tight">
            洞洞杂货铺漫画
          </h1>
          <p className="text-base md:text-lg text-background-200 mb-8 leading-relaxed">
            每一件物品都藏着一个故事，每一页漫画都是一次温暖相遇。<br className="hidden sm:block" />
            全集免费在线阅读，随时随地畅享追漫乐趣。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/comic/dongdong-zahuopu"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-base font-label whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-book-open-line mr-2"></i>开始阅读
            </Link>
            <Link
              to="/category/all"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-base font-label whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors"
            >
              <i className="ri-grid-line mr-2"></i>浏览全部
            </Link>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-6 text-background-200 text-sm">
          <div className="flex items-center gap-1">
            <i className="ri-book-read-line"></i>
            <span>海量漫画</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-background-300"></div>
          <div className="flex items-center gap-1">
            <i className="ri-download-cloud-line"></i>
            <span>每日更新</span>
          </div>
          <div className="w-1 h-1 rounded-full bg-background-300"></div>
          <div className="flex items-center gap-1">
            <i className="ri-coin-line"></i>
            <span>完全免费</span>
          </div>
        </div>
      </div>
    </section>
  );
}